import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../features/auth/AuthContext";
import { LetestTeacher, resetLetestTeacher } from "../../../../state/actions/teacherListAction";
import DataTableListing from "../../../../components/DataTableListing/DataTableListing";
import { useNavigate } from "react-router";
import search_bar from "../../../../assets/images/search.svg";
import sort_icon from "../../../../assets/images/sort.png";
import AddProfilePopup from "../../../../components/Add Profile/AddProfilePopup";
import { toast } from "react-toastify";
import api from "../../../../api/api";
import EnrollmentResponsiveCards from "../RecentEnrollment/EnrollmentResponsiveCards";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import SearchComponent from "../../../../components/SearchComponent/SearchComponent";

const DashboardList = ({defaultTab }) => {
    const [activeTab, setActiveTab] = useState(defaultTab || "Student"); // Default active tab is 'lessons'
    const handleTabClick = (newActiveTab) => {
        setActiveTab(newActiveTab);
        setSearchText("");
        setSortValue("");
        setGradeValue("");
        setSubjectValue("");
    };
    const { token } = useAuth();
    const dispatch = useDispatch();
    const { school_id } = useSelector((state) => state.globalState);
    const letestteacherlist = useSelector((state) => state.letestteacherlist);
    const globalState = useSelector((state) => state.globalState);
    const navigate = useNavigate();
    const getLetestTeacheretils = () => {
        dispatch(LetestTeacher(token, activeTab, school_id));
    };
    const [searchText, setSearchText] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [sortValue, setSortValue] = useState("Newest First");
    const [showSortMenu, setShowSortMenu] = useState(false);
    const [gradeValue, setGradeValue] = useState("");
    const [showGradeMenu, setShowGradeMenu] = useState(false);
    // const sortRef = useRef(null);
    // const gradeRef = useRef(null);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [statuses, setStatuses] = useState({});
    const [subjectValue, setSubjectValue] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    // const filterRef = useRef(null);
     const desktopSortRef = useRef(null);
    const desktopGradeRef = useRef(null);
    const desktopFilterRef = useRef(null);

    const mobileSortRef = useRef(null);
    const mobileGradeRef = useRef(null);
    const mobileFilterRef = useRef(null);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    useEffect(() => {
      const handleResize = () => setIsMobile(window.innerWidth < 1024);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 400); 
    return () => clearTimeout(timer);
    }, [searchText]); 

    // useEffect(() => {
    // const handleClickOutside = (e) => {
    //     if (sortRef.current && !sortRef.current.contains(e.target)) setShowSortMenu(false);  // ← setShowSortMenu
    //     if (gradeRef.current && !gradeRef.current.contains(e.target)) setShowGradeMenu(false); // ← gradeRef, setShowGradeMenu
    //     if (filterRef.current && !filterRef.current.contains(e.target)) setShowFilterMenu(false);
    // };
    // document.addEventListener("mousedown", handleClickOutside);
    // return () => document.removeEventListener("mousedown", handleClickOutside);
    // }, []);

      useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      desktopSortRef.current &&
      !desktopSortRef.current.contains(e.target) &&
      mobileSortRef.current &&
      !mobileSortRef.current.contains(e.target)
    ) {
      setShowSortMenu(false);
    }

    if (
      desktopGradeRef.current &&
      !desktopGradeRef.current.contains(e.target) &&
      mobileGradeRef.current &&
      !mobileGradeRef.current.contains(e.target)
    ) {
      setShowGradeMenu(false);
    }

    if (
      desktopFilterRef.current &&
      !desktopFilterRef.current.contains(e.target) &&
      mobileFilterRef.current &&
      !mobileFilterRef.current.contains(e.target)
    ) {
      setShowFilterMenu(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

 useEffect(() => {
  dispatch(LetestTeacher(
    token,
    activeTab,
    school_id,
    sortValue || undefined,
    debouncedSearch || undefined,
    gradeValue || undefined,
    subjectValue || undefined
  ));
}, [
  activeTab,
  sortValue,
  debouncedSearch,
  gradeValue,
  subjectValue,
  token,
  school_id
]);
    // useEffect(() => {
    //     getLetestTeacheretils();
    //     return () => {
    //         dispatch(resetLetestTeacher());
    //     };
    // }, [activeTab]);
    useEffect(() => {
        return () => {
            dispatch(resetLetestTeacher());
        };
    }, []);

  const isControlled = !!defaultTab; // just converts the value to boolean as true or false
    useEffect(() => {
        if (defaultTab) {
        setActiveTab(defaultTab);
        }
    }, [defaultTab]); // runs whenever tab changes (teachers and studnets)

    const sortOptions = [
        { label: "Name : A - Z", value: "Name:A-Z" },
        { label: "Name : Z - A", value: "Name:Z-A" },
        { label: "Newest First", value: "Newest First" },
        { label: "Oldest First", value: "Oldest First" },
    ];

    const formatDate = (dateStr) => {
        if (!dateStr) return "—";
        const date = new Date(dateStr);
        const day = date.toLocaleString("en-GB", { day: "2-digit" });
        const month = date.toLocaleString("en-GB", { month: "short" });
        const year = date.getFullYear();
        return `${day} ${month}, ${year}`;
    };

    const toggleStatus = async (id, currentStatus, user_id) => {
        setStatuses((prev) => ({
            ...prev,
            [id]: prev[id] !== undefined ? !prev[id] : !currentStatus,
        }));

        try {
            const result = await api.post(
            "super-admin/school/active-deactive/",
            { user_id, active: !currentStatus },
            { headers: { "Content-Type": "application/json", Authorization: `Token ${token}` } }
            );
            if (result.status === 200) {
            toast.success(!currentStatus ? "Account has been enabled." : "Account has been disabled.");
            } else {
            setStatuses((prev) => ({ ...prev, [id]: currentStatus }));
            }
        } catch (error) {
            setStatuses((prev) => ({ ...prev, [id]: currentStatus }));
        }
    };

    const studentColumns = [
        {
        key: "student_profile_pic",
        title: "Name",
        render: (value, row) => (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {value ? (
                <img src={value} alt={row.name} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
            ) : (
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e2e8f0", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#94a3b8", fontWeight: 600 }}>
                {row.name?.charAt(0)}
                </div>
            )}
            <span>{row.name}</span>
            </div>
        ),
        },
        { key: "student_id", title: "Student ID",   render: (v) => <span>{v}</span> },
        { key: "grade",      title: "Grade",        render: (v) => <span>{v}</span> },
        { key: "email",      title: "Email Id",     render: (v) => <span>{v}</span> },
        { key: "created_at", title: "Joining Date", render: (v) => formatDate(v) },
        { key: "status", title: "Status", render: (_, row) => {
        const isActive = statuses[row.student_id] ?? row.active;
        return (
            <div 
            onClick={() => toggleStatus(row.student_id, isActive, row.user_id)}
            style={{ width: 90, height: 30, borderRadius: 999, background: isActive ? "#E0F4FF" : "#f1f5f9", position: "relative", display: "flex", alignItems: "center", flexShrink: 0 }}>
            <span style={{ position: "absolute", left: isActive ? 12 : 30, fontSize: 12.5, fontWeight: 500, color: isActive ? "#0068FF" : "#94a3b8", userSelect: "none" }}>
                {isActive ? "Active" : "Inactive"}
            </span>
            <div style={{ width: 22, height: 22, borderRadius: "50%", background: "#fff", position: "absolute", ...(isActive ? { right: 4 } : { left: 4 }), boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }} />
            </div>
        );
        }},
        {
        key: "action", title: "Action",
        render: (_, row) => (
            <span style={{ color: "#0068FF", fontSize: 13.5, fontWeight: 500, cursor: "pointer" }}
            onClick={(e) => { e.stopPropagation(); navigate(`/student/${row.student_id}`); }}>
            View Profile
            </span>
        ),
        },
    ];

    const teacherColumns = [
        {
        key: "ai_avatar",
        title: "Teacher Name",
        render: (value, row) => (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {value ? (
                <img src={value} alt={row.name} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
            ) : (
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e2e8f0", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#94a3b8", fontWeight: 600 }}>
                {row.name?.charAt(0)}
                </div>
            )}
            <span>{row.name}</span>
            </div>
        ),
        },
        { key: "teacher_id", title: "Teacher Id",  render: (v) => <span>{v}</span> },
        { key: "email",      title: "Email Id",    render: (v) => <span>{v}</span> },
        { key: "created_at", title: "Joining Date",render: (v) => formatDate(v) },
        { key: "status", title: "Status", render: (_, row) => {
        const isActive = statuses[row.teacher_id] ?? row.active;;
        return (
            <div 
             onClick={() => toggleStatus(row.teacher_id, isActive, row.user_id)}
             style={{ width: 90, height: 30, borderRadius: 999, background: isActive ? "#E0F4FF" : "#f1f5f9", position: "relative", display: "flex", alignItems: "center", flexShrink: 0 }}>
            <span style={{ position: "absolute", left: isActive ? 12 : 30, fontSize: 12.5, fontWeight: 500, color: isActive ? "#0068FF" : "#94a3b8", userSelect: "none" }}>
                {isActive ? "Active" : "Inactive"}
            </span>
            <div style={{ width: 22, height: 22, borderRadius: "50%", background: "#fff", position: "absolute", ...(isActive ? { right: 4 } : { left: 4 }), boxShadow: "0 1px 4px rgba(0,0,0,0.15)" }} />
            </div>
        );
        }},
        {
        key: "action", title: "Action",
        render: (_, row) => (
            <span style={{ color: "#0068FF", fontSize: 13.5, fontWeight: 500, cursor: "pointer" }}
            onClick={(e) => { e.stopPropagation(); navigate(`/TeacherProfile/${row.teacher_id}`); }}>
            View Profile
            </span>
        ),
        },
    ];
const subjectEntries = Object.entries(globalState?.datalist?.top_ten_subjects || {});
    return (
        <>
        {/* ── AddProfilePopup ── */}
        {showAddPopup && (
        <AddProfilePopup
            entity={activeTab === "Student" ? "Student" : "Teacher"}
            toggleshowAddProfile={() => {
            setShowAddPopup(false);
            // re-fetch after adding
            dispatch(LetestTeacher(token, activeTab, school_id, sortValue || undefined, debouncedSearch || undefined, gradeValue || undefined));
            }}
        />
        )}
            <div className="Dashboard-List-Table">
                <div className="Dashboard-List-Table-wrapper">
                    <div className="view-lessons-section">
                        <div className="view-lessons-wrapper">
                            {
                                !isControlled && (  // iscontrolled hide the internal buttons (following buttons ) to avoid duplicates and shows the buttons from RecentEnrollment component 
                                <div className="view-lessons-btn-container teacehr-tab-setion">

                                    <button
                                        className={`tab-button ${activeTab === "Teacher" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("Teacher")}
                                    >
                                        Recently Added Teachers
                                    </button>
                                    <button
                                        className={`tab-button ${activeTab === "Student" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("Student")}
                                    >
                                        Recently Added Students
                                    </button>
                                </div>
                           ) }
                            {/* Toolbar */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "12px 0", gap: 10 }}>
                            {/* Search */}
                            <SearchComponent
                                search={search_bar}
                                searchPlaceholder={activeTab === "Student" ? "Search Students" : "Search Teachers"}
                                value={searchText}
                                onchange={(e) => setSearchText(e.target.value)}
                            />
                           {/*  <div className="search-bar">
                                <img src={search_bar} alt="search" />
                                <div className="search-divider"></div>
                                <input
                                placeholder={activeTab === "Student" ? "Search Students" : "Search Teachers"}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                />
                            </div> */}

                            <div className="hidden md:!flex">
                                {/* Grade — Students only */}
                                {activeTab === "Student" && (
                                <div
                                    className="hidden md:!block"
                                    style={{ position: "relative" }}
                                    ref={desktopGradeRef}
                                    >
                                    <button  className="sort-button"
                                    onClick={() => {
                                    setShowGradeMenu((prev) => !prev);
                                    }}>
                                     Grade  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path
                                        d="M2 4L6 8L10 4"
                                        stroke="#64748b"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    </svg>
                                    </button>
                                    {showGradeMenu && (
                                    <div className="sort-menu" style={{ minWidth: 170 }}>
                                    <div
                                        style={{
                                        padding: "8px 12px",
                                        fontSize: 12,
                                        fontWeight: 600,
                                        color: "#64748b",
                                        }}
                                    >
                                        Grade
                                    </div>
                                        <div className="sort-options"
                                        onClick={() => { setGradeValue(""); setShowGradeMenu(false); }}
                                        style={{ color: !gradeValue ? "#0068FF" : "#374151", fontWeight: !gradeValue ? 600 : 400 }}
                                        >
                                        All Grades
                                        </div>
                                        {/* {[1,2,3,4,5,6,7,8,9,10,11,12].map((g) => ( */}
                                        {Object.keys(globalState.grade_details?.grade ?? {}).map((g) => (
                                        <div className="sort-options" key={g}
                                            onClick={() => { setGradeValue(String(g)); setShowGradeMenu(false); }}
                                            style={{
                                            color: gradeValue === String(g) ? "#0068FF" : "#374151",
                                            fontWeight: gradeValue === String(g) ? 600 : 400,
                                            background: gradeValue === String(g) ? "#f0f7ff" : "#fff",
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                                            onMouseLeave={(e) => e.currentTarget.style.background = gradeValue === String(g) ? "#f0f7ff" : "#fff"}
                                        >
                                            {/* Grade {g} */}
                                            {globalState.grade_details.grade[g]}
                                        </div>
                                        ))}
                                    </div>
                                    )}
                                </div>
                                )}
                                 {/* {activeTab !== "Student" && (
                                <div style={{ position: "relative" }} ref={filterRef}>
                                    <button
                                        className="sort-button"
                                        onClick={() => setShowFilterMenu((prev) => !prev)}
                                    >
                                        <i className="fa-solid fa-sliders" style={{ marginRight: 6 }}></i>
                                        Filter
                                    </button>

                                    {showFilterMenu && (
                                        <div className="sort-menu" style={{ minWidth: 200 }}>
                                            
                                            <div style={{ padding: "8px 12px", fontWeight: 600 }}>Subject</div>

                                           
                                            <div
                                            className="sort-options"
                                            onClick={() => {
                                                setSubjectValue(""); 
                                                setShowFilterMenu(false);
                                            }}
                                            style={{
                                                color: !subjectValue ? "#0068FF" : "#374151",
                                                fontWeight: !subjectValue ? 600 : 400,
                                            }}
                                            >
                                            All Subjects
                                            </div>

                                            
                                            {subjectEntries.map(([id, name]) => (
                                            <div
                                                key={id}    
                                                className="sort-options"
                                                onClick={() => {
                                                setSubjectValue(id); 
                                                setShowFilterMenu(false);
                                                }}
                                                style={{
                                                color: subjectValue === id ? "#0068FF" : "#374151",
                                                fontWeight: subjectValue === id ? 600 : 400,
                                                background: subjectValue === id ? "#f0f7ff" : "#fff",
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                                                onMouseLeave={(e) => e.currentTarget.style.background = subjectValue === id ? "#f0f7ff" : "#fff"}
                                            >
                                                {name} 
                                            </div>
                                            ))}
                                        </div>
                                        )}
                                    </div>
                                 )} */}

                                {/* Sort */}
                                <div style={{ position: "relative" }} ref={desktopSortRef}>
                                <button className="sort-button" onClick={() => setShowSortMenu((prev) => !prev)}>
                                    <img src={sort_icon} alt="sort" />
                                    Sort
                                </button>
                                {showSortMenu && (
                                    <div className="sort-menu">
                                    {sortOptions.map((option) => (
                                        <div className="sort-options" key={option.value}
                                        onClick={() => { setSortValue(option.value); setShowSortMenu(false); }}
                                        style={{
                                            color: sortValue === option.value ? "#0068FF" : "#374151",
                                            fontWeight: sortValue === option.value ? 600 : 400,
                                            background: sortValue === option.value ? "#f0f7ff" : "#fff",
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                                        onMouseLeave={(e) => e.currentTarget.style.background = sortValue === option.value ? "#f0f7ff" : "#fff"}
                                        >
                                        {option.label}
                                        </div>
                                    ))}
                                    </div>
                                )}
                                </div>

                                {/* Add button */}
                                <button className="add-role-button" onClick={() => setShowAddPopup(true)}>
                                + Add {activeTab === "Student" ? "Student" : "Teacher"}
                                </button>
                            </div>
                            </div>
                             {/* MOBILE VERSION */}
                            <div className="sm:hidden px-2 mt-3 space-y-2">
                                <button
                                onClick={() => setShowAddPopup(true)}
                                className="w-full py-2 bg-blue-600 text-white border-none text-sm rounded-lg font-medium"
                                >
                                + Add {activeTab === "Student" ? "Student" : "Teacher"}
                                </button>
                                <div className="flex items-center justify-between">
                                {activeTab === "Student" ? (
                                    <div className="relative" ref={mobileGradeRef}>
                                    <button
                                        onClick={() => setShowGradeMenu((prev) => !prev)}
                                        className="flex items-center gap-2 border-none px-3 py-2 bg-white rounded-lg text-sm"
                                    >
                                        {gradeValue ? `Grade ${gradeValue}` : "Grade"}
                                         <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path
                                            d="M2 4L6 8L10 4"
                                            stroke="#64748b"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        </svg>
                                    </button>

                                    {showGradeMenu && (
                                        <div className="absolute left-0 mt-2 w-40 max-h-48 overflow-y-auto bg-white border rounded-lg shadow-md z-50">
                                        <div
                                            className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                            onClick={() => {
                                            setGradeValue("");
                                            setShowGradeMenu(false);
                                            }}
                                        >
                                            All Grades
                                        </div>

                                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((g) => (
                                            <div
                                            key={g}
                                            className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                                                gradeValue === String(g)
                                                ? "text-blue-600 font-semibold"
                                                : ""
                                            }`}
                                            onClick={() => {
                                                setGradeValue(String(g));
                                                setShowGradeMenu(false);
                                            }}
                                            >
                                            Grade {g}
                                            </div>
                                        ))}
                                        </div>
                                    )}
                                    </div>
                                ) : (
                                    <div className="relative" ref={mobileFilterRef}>
                                    <button
                                        onClick={() => setShowFilterMenu((prev) => !prev)}
                                        className="flex items-center gap-2 px-3 border-none py-2 bg-white rounded-lg text-sm"
                                    >
                                        <i className="fa-solid fa-sliders"></i>
                                        Filter
                                    </button>

                                    {showFilterMenu && (
                                        <div className="absolute left-0 mt-2 w-48 max-h-48 overflow-y-auto bg-white border rounded-lg shadow-md z-50">
                                        <div className="px-3 py-2 font-semibold text-sm">
                                            Subject
                                        </div>

                                        <div
                                            className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                            onClick={() => {
                                            setSubjectValue("");
                                            setShowFilterMenu(false);
                                            }}
                                        >
                                            All Subjects
                                        </div>

                                        {subjectEntries.map(([id, name]) => (
                                            <div
                                            key={id}
                                            className={`px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                                                subjectValue === id
                                                ? "text-blue-600 font-semibold"
                                                : ""
                                            }`}
                                            onClick={() => {
                                                setSubjectValue(id);
                                                setShowFilterMenu(false);
                                            }}
                                            >
                                            {name}
                                            </div>
                                        ))}
                                        </div>
                                    )}
                                    </div>
                                )}

                                {/* SORT */}
                                <div className="relative" ref={mobileSortRef}>
                                    <button
                                    onClick={() => setShowSortMenu((prev) => !prev)}
                                    className="flex items-center gap-2 border-none px-3 py-2 bg-white rounded-lg text-sm"
                                    >
                                    <img src={sort_icon} alt="sort" className="w-4 h-4" />
                                    Sort
                                    </button>

                                    {showSortMenu && (
                                    <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-md z-50">
                                        {sortOptions.map((option) => (
                                        <div
                                            key={option.value}
                                            className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                            onClick={() => {
                                            setSortValue(option.value);
                                            setShowSortMenu(false);
                                            }}
                                        >
                                            {option.label}
                                        </div>
                                        ))}
                                    </div>
                                    )}
                                </div>
                                </div>
                            </div>
                            <div className="tab-content">
                                {isMobile ? (
                                <EnrollmentResponsiveCards
                                    data={(activeTab === "Student"
                                    ? letestteacherlist.students ?? []
                                    : letestteacherlist.teachers ?? []
                                    ).map((item) => ({
                                    id:
                                        activeTab === "Student"
                                        ? item.student_id
                                        : item.teacher_id,
                                    profilePic:
                                        activeTab === "Student"
                                        ? item.student_profile_pic
                                        : item.ai_avatar,
                                    is_active: item.active ?? false,
                                    name: item.name || "Unknown",
                                    email: item.email || "-",
                                    studentId: item.student_id,
                                    teacherId: item.teacher_id,
                                    user_id: item.user_id,
                                    grade: item.grade,
                                    joinDate: new Date(item.created_at)
                                        .toLocaleDateString("en-US", {
                                        month: "short",
                                        day: "2-digit",
                                        year: "numeric",
                                        })
                                        .replace(",", "-")
                                        .replace(" ", "-"),
                                    }))}
                                    onToggleStatus={(id, is_active, user_id) =>
                                    toggleStatus(id, is_active, user_id)
                                    }
                                    statuses={statuses}
                                    userType={activeTab === "Student" ? "student" : "teacher"}
                                />
                                ) : (
                                <DataTableListing
                                    columns={
                                    activeTab === "Student" ? studentColumns : teacherColumns
                                    }
                                    dataSource={
                                    activeTab === "Student"
                                        ? letestteacherlist.students ?? []
                                        : letestteacherlist.teachers ?? []
                                    }
                                    rowKey={
                                    activeTab === "Student" ? "student_id" : "teacher_id"
                                    }
                                    pagination={false}
                                    checkable={false}
                                    loading={letestteacherlist.isLoading}
                                    emptyText={
                                    activeTab === "Student"
                                        ? "No Students Found"
                                        : "No Teachers Found"
                                    }
                                    bordered={false}
                                    size="default"
                                    rowHoverColor="#F7F7F7"
                                />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default DashboardList;
